<template>
  <broadcast v-if="isLottery" />
  <award-notice v-else />
</template>

<script>
import Broadcast from './Broadcast.vue'
import AwardNotice from '../AwardNotice.vue'

export default {
  name: 'AwardNoticeWrapper',
  components: { Broadcast, AwardNotice },
  data() {
    return {
    }
  },
  computed:{
    isLottery(){
      return this.$bus.lottery?.enableLottery
    }
  }
}
</script>

<style scoped>

</style>